<template>
    <div class="public-page">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <div class="content">
            <!-- 面包屑 -->
            <div class="breadbox">
                <div class="container1">
                    <div class="f_cont">
                        <router-link to="/">首页</router-link>
                        <span>&gt;</span>
                        <a href="javascript:;">免责声明</a>
                    </div>
                </div>
            </div>
            <!-- 公共页面内容1 -->
            <div class="public-page1">
                <div class="container1">
                    <ul class="c-left font18">
                        <li><router-link to="" class="active">免责声明</router-link></li>
                        <li><router-link :to="{ name: 'privacyPolicy' }">隐私政策</router-link></li>
                    </ul>
                    <div class="c-right">
                        <h1 class="c-title font40 pingFang-Bold">免责声明</h1>
                        <div class="c-content">
                            <p>
                                一、免责条款
                                <br />
                                <br />
                                1、内容待补充本站转载的文章或者资源非原创，其版权和文责属于原作者。
                                <br />
                                <br />
                                2、本站用户投递的原创文章或者资源，其版权和文责属于投递者，除非另有说明。
                                <br />
                                <br />
                                3、由数位（xxx.com）编辑采写的文章或者资源均在文内有明显标记，责任编辑对文章的真实性和原创性负责。转载时只需标明出处和原作者即可，但对于擅自修改原文导致文意改变引发的问题，数位（xxx.com）不承担任何责任。
                                <br />
                                <br />
                                4、报道中出现的商标、专利和其他版权所有的信息，其版权属于其合法持有人。
                                <br />
                                <br />
                                5、数位（xxx.com）遵守DMCA notices，对侵权内容链接进行删除。对可以提供充分证据的侵权信息， prmuban 将在确认后24小时内删除。
                                <br />
                                <br />
                                6、数位（xxx.com）服从其服务器节点所在地的法律管辖。
                                <br />
                                <br />
                                二、评论须知
                                <br />
                                <br />
                                1、网友评论仅供其表达个人看法，并不表明PR模板网（prmuban.com）证实、证伪、支持或反对评论中的信息。
                                <br />
                                <br />
                                2、评论者同时受到其自身所在地和PR模板网（prmuban.com）服务器所在地的法律管辖。请注意不要发布违反评论者所在地或本站服务器所在地法律的信息，否则信息有可能被删除。本站可能用技术手段限制您的访问，也可能依下述“有关您的隐私”部分之理由而依法披露您的信息。请认真对待以上警告。
                                <br />
                                <br />
                                3、发表评论表示您授权PR模板网（prmuban.com）任意使用您发布的信息，以及制作衍生产品。具体地说，对于您选择并张贴在任何本服务中可公开获取区域的内容，您同意PR模板网（prmuban.com）在全世界范围内具有免费的、永远的、不可撤销的、非独家的和完全再许可的权利和许可，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品，传播、表演和展示此等内容（整体或部分），和/或将此等内容编入其他任何形式的作品、媒体、或技术中，不论是当前已知的或以后开发的。
                                <br />
                                <br />
                                4、PR模板网（prmuban.com）可能在不事先通知您的情况下更改或中止某项正在运营的服务，也不会对传输过程中造成的信息的偶然丢失承担责任或义务。
                                <br />
                                <br />
                                5、评论时请遵守公共道德，谢绝地域攻击、人身攻击。请遵守理性，宽容，换位思考的原则。
                                <br />
                                <br />
                                三、用户隐私
                                <br />
                                <br />
                                1、PR模板网（prmuban.com）主动收集的信息均与您的个人身份没有关联，这些信息用以改善我们的服务和统计用于广告主的网站整体信息。
                                <br />
                                <br />
                                2、PR模板网（prmuban.com） 使用的某些第三方服务可能收集您的信息，请参考它们各自的隐私声明。
                                <br />
                                <br />
                                3、PR模板网（prmuban.com） 可根据法律要求对内容进行披露，以（a）遵守法律程序；（b）执行服务条款；
                                （c）为了答复因张贴内容侵犯第三方权利而引起的主张；或（d）为了保护PR模板网（prmuban.com）及其用户和公众的权利、财产、或人员的安全；（e）PR模板网（prmuban.com）及其指定的人将有权利移走任何违反服务器所在地法律、法规、本页条款的用户，或其他PR模板网（prmuban.com）认为不可接受的内容。
                                <br />
                                <br />
                                4、PR模板网（prmuban.com）未来可能视情况对本页条款进行修订或解释。
                                <br />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '../components/navBar.vue';
export default {
    name: '',
    data() {
        return {};
    },
    created() {},
    mounted() {
        setTimeout(() => {
            this.setDomAnimate(tagIndex => {
                console.log(tagIndex);
                if (tagIndex == 0) {
                    this.setModuleAnimate('us1Animate', 'animate-fadeInUp-module');
                }
            });
        }, 500);
    },
    computed: {},
    methods: {},
    components: { navBar },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    box-shadow: 0 4px 40px rgba(50, 51, 51, 0.06);
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}
.public-page {
    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: #ffffff;
    }
    // banner
    // 4公共页面内容1
    .public-page1 {
        padding: 120px 0;
        @media @max-xs {
            padding: 60px 0;
        }
        .container1 {
            display: flex;
            align-items: flex-start;
            @media @max-xs {
                flex-wrap: wrap;
            }
            .c-left {
                flex-shrink: 0;
                width: 200px;
                position: sticky;
                position: -webkit-sticky;
                top: 100px;
                @media @max-sm {
                    width: 120px;
                }
                @media @max-xs {
                    display: flex;
                    width: 100%;
                    position: static;
                }
                li {
                    margin-bottom: 40px;
                    @media @max-xs {
                        margin: 0 20px 0 0;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                    a {
                        position: relative;
                        color: #333;
                        padding-bottom: 8px;
                        &::before {
                            content: '';
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            height: 2px;
                            transition: all 0.3s;
                        }
                        &.active {
                            color: #eb5405;
                            &::before {
                                background: #eb5405;
                            }
                        }
                    }
                }
            }
            .c-right {
                width: 100%;
                @media @max-xs {
                    margin-top: 30px;
                }
                .c-title {
                    margin-bottom: 40px;
                    color: #333;
                    @media @max-xs {
                        margin-bottom: 20px;
                    }
                }
                .c-content {
                    color: #65697f;
                    img {
                        max-width: 100%;
                        height: auto !important;
                    }
                }
            }
        }
    }
}
</style>
